import { connect } from "react-redux";

import { actions as compareActions } from "../compare";
import { actions as searchActions } from "../search";
import { actions as locationActions } from "./Location.redux";
import Location from "./Location.view";

const mapStateToProps = state => ({
  authenticated: !!state.login.auth.expires,
  comparedListings: state.comparedListings,
  locationsCount: state.locationsCount,
  locationsError: state.locationsError,
  locationsLoading: state.locationsLoading,
  searchError: state.searchError,
  searchLoading: state.searchLoading,
  searchResults: state.searchResults,
  targetDevice: state.targetDevice,
  userWatchedListings: state.login.userWatchedListings,
});

const mapDispatchToProps = dispatch => ({
  addToComparedListings: listing => dispatch(compareActions.add(listing)),
  locationsFetch: () => dispatch(locationActions.fetch()),
  locationsLookup: slug => dispatch(locationActions.lookup(slug)),
  fetchSearchResults: (query, page) =>
    dispatch(searchActions.fetch(query, page)),
  removeFromComparedListings: equipmentId =>
    dispatch(compareActions.remove(equipmentId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Location);
